var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFairphoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 20,
    width: 80,
    height: 80,
    rx: 8,
    fill: "#27292E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104 69.6V40.8C104 38.16 101.84 36 99.2 36H70.4C67.76 36 65.6 38.16 65.6 40.8V69.6C65.6 72.24 67.76 74.4 70.4 74.4H99.2C101.84 74.4 104 72.24 104 69.6ZM78.56 61.272L82.472 66.504L88.664 58.776C89.144 58.176 90.056 58.176 90.536 58.776L97.64 67.656C98.264 68.448 97.712 69.6 96.704 69.6H72.8C71.816 69.6 71.24 68.472 71.84 67.68L76.64 61.272C77.12 60.648 78.08 60.648 78.56 61.272ZM56 48V79.2C56 81.84 58.16 84 60.8 84H92C93.32 84 94.4 82.92 94.4 81.6C94.4 80.28 93.32 79.2 92 79.2H63.2C61.88 79.2 60.8 78.12 60.8 76.8V48C60.8 46.68 59.72 45.6 58.4 45.6C57.08 45.6 56 46.68 56 48Z",
    fill: "#A6B7FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 160,
    height: 160,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2775 0 0 0 0 0.225 0 0 0 0 0.6 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFairphoto);
export default __webpack_public_path__ + "static/media/Fairphoto.8f2a83200e5e764e167dde2b3da3a6f4.svg";
export { ForwardRef as ReactComponent };